export function IconMenu() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill="currentColor" d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm0 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>
    );
}
